
//  This class is responsible for declare Schema of FileUpload
export class FileUpload {
  companyId: number;
  fileName: string;
  fileSize: any;
  documentId: number;
  constructor() { }
}
